import { Leerkr8PlaythroughRequest, Leerkr8PlaythroughResponse } from '@core/saves/leerkr8/types';
import { getDefaultSaveState, ISaveState } from '@core/saves/saves.interface';
import { of } from 'rxjs';
import { ILeerkr8ApiService } from './leerkr8-api.service.interface';

export class MockLeerkr8ApiService implements ILeerkr8ApiService {
  startSession(playerCode: string) {
    return of({
      sessionId: 'mock-session-id',
      playerCode,
      localeId: 'en',
      properties: { mock: 'property' },
    });
  }

  async getGameSave(sessionId: string, playerCode: string): Promise<ISaveState> {
    return Promise.resolve(getDefaultSaveState());
  }

  setGameSave(sessionId: string, playerCode: string, save: ISaveState) {
    return of({ success: true });
  }

  activateDevice(activationCode: string, deviceIdentifier: string, deviceName: string) {
    return of({
      instituteName: 'Mock Institute',
      token: 'mock-token',
    });
  }

  getPlayerGroup(deviceToken: string, deviceIdentifier: string, playerGroupCode: string) {
    return of({
      playerCodes: ['mock-player-1', 'mock-player-2'],
      playerSaves: [
        {
          properties: { mock: 'property' },
          nickname: 'MockNick1',
          fullName: 'Mock Full Name 1',
          localeId: 'en',
        },
        {
          properties: { mock: 'property' },
          nickname: 'MockNick2',
          fullName: 'Mock Full Name 2',
          localeId: 'en',
        },
      ],
      skipParentalGuard: true,
    });
  }

  postPlaythrough(sessionId: string, playerCode: string, playthrough: Leerkr8PlaythroughRequest) {
    return of({} as Leerkr8PlaythroughResponse);
  }
}
